import { Steps, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { FaTruckMoving } from "react-icons/fa6";
import { FaRegFolderOpen } from "react-icons/fa6";
import { CreationOT } from "./CreationOT";
import { AssignationOT } from "./AssignationOT";
import { TransportOrderFormContext } from "../store/_context";
import { OrderTransportConstant } from "../core/_constant";

type PropsType = {
  onFinish: () => void;
  onRefetch?: () => void;
  initialValue?: any;
};

type StepsType = {
  title: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
  description?: React.ReactNode;
};

export const TransportOrderForm = ({
  onFinish,
  onRefetch,
  initialValue,
}: PropsType) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [otData, setOtData] = useState<any>(null);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (
      initialValue &&
      initialValue?.transportOrderState &&
      initialValue?.transportOrderState?.id === OrderTransportConstant.ASSIGNED
    ) {
      setCurrentStep(1);
    }
  }, [initialValue]);

  useEffect(() => {
    setData({
      ...initialValue,
      ...otData,
    });
  }, [otData, initialValue]);

  const steps: Array<StepsType> = [
    {
      title: initialValue
        ? "Modification de l'ordre de transport"
        : "Création de l'ordre de transport",
      icon: <FaRegFolderOpen />,
      content: <CreationOT />,
      description: "",
    },
    {
      title: "Assignation au camion",
      icon: <FaTruckMoving />,
      content: <AssignationOT />,
      description: data?.reference ? (
        <div>
          <Tag color="#2db7f5">{data?.truck?.reference || data?.particularTruckNumber} </Tag>
        </div>
      ) : (
        ""
      ),
    },
  ];

  const handleNext = () => {
    // if (currentStep < steps.length) {
    // }
    setCurrentStep((prev: number) => (prev += 1));
  };

  const handlePrev = () => {
    if (currentStep !== 0) {
      setCurrentStep((prev: number) => (prev -= 1));
    }
  };

  return (
    <div>
      <TransportOrderFormContext.Provider
        value={{
          otData,
          initialValue,
          handleNext,
          handlePrev,
          onFinish,
          setOtData,
          onRefetch,
        }}
      >
        <Steps
          size="small"
          current={currentStep}
          items={steps}
          {...(otData || initialValue
            ? {
                onChange: setCurrentStep,
              }
            : {})}
        />
        <div className="mt-4">{steps[currentStep]?.content}</div>
      </TransportOrderFormContext.Provider>
    </div>
  );
};
